import { REGIMES_CODE, REGIMES_NAME } from '../../@types/Regime.type';

/**
 * Regimes a user can regularize monthly back-declarations for. `regimeCode`
 * feeds RegimeFFT when building the cart payload; `value` keys the catalog slug.
 */
export const REGIMES = [
	{
		name: REGIMES_NAME.PLATAFORMAS_TECNOLOGICAS,
		value: 'platec',
		regimeCode: REGIMES_CODE.PLATAFORMAS_TECNOLOGICAS,
	},
	{
		name: REGIMES_NAME.RESICO,
		value: 'resico',
		regimeCode: REGIMES_CODE.RESICO,
	},
	{
		name: REGIMES_NAME.ACTIVIDAD_EMPRESARIAL,
		value: 'business',
		regimeCode: REGIMES_CODE.ACTIVIDAD_EMPRESARIAL,
	},
] as const;

export type RegimeValue = (typeof REGIMES)[number]['value'];

/**
 * Catalog slugs (heru-sales-transaction-engine /pricing/catalog) the regularization surfaces
 * resolve against. The catalog is the single source of truth for prices + ids.
 */
export const REG_MONTHLY_SLUG_BY_REGIME: Record<RegimeValue, string> = {
	platec: 'reg_pt_full',
	resico: 'reg_resico_plus',
	business: 'reg_act_emp',
};

/** Prior-year annual back-declaration (catalog `regularizations`, `unit`). */
export const REG_ANNUAL_COMPLEX_SLUG = 'declaración_anual_compleja';

/** Current-year annual declaration (catalog `annual`, `one_time`). */
export const ANNUAL_SUBSCRIPTION_SLUG = 'suscripcion_declaracion_anual';
